export default {
    'AUTH.LINK_SENT.TITLE': 'Lien envoyé !',
    'AUTH.LINK_SENT.ASIDE': 'Rendez-vous dans votre boite mail, si votre compte existe vous recevrez un email avec ' +
        'un lien pour créer un nouveau mot de passe.',
    'AUTH.LINK_SENT.BACK': 'Retour à la page de connexion',
};
